module.exports = __webpack_public_path__ + "static/media/post-exercise.9f768e07.svg";